// extracted by mini-css-extract-plugin
export default {"modal":"CO-z","error":"DO-z","disabled":"EO-z","fields":"FO-z","errorMsg":"GO-z","footer":"HO-z","formContentWrapper":"IO-z","productImage":"JO-z","overlay":"KO-z"};